import { render, staticRenderFns } from "./ShopIncomeVoucher.vue?vue&type=template&id=797e8254&scoped=true"
import script from "./ShopIncomeVoucher.vue?vue&type=script&lang=js"
export * from "./ShopIncomeVoucher.vue?vue&type=script&lang=js"
import style0 from "./ShopIncomeVoucher.vue?vue&type=style&index=0&id=797e8254&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797e8254",
  null
  
)

export default component.exports